export default __webpack_public_path__ + "static/media/RequestRemittance.a1f4d7ac.svg";